import { render, staticRenderFns } from "./DetailPopup.vue?vue&type=template&id=6ea3b72d"
import script from "./DetailPopup.vue?vue&type=script&lang=js"
export * from "./DetailPopup.vue?vue&type=script&lang=js"
import style0 from "./DetailPopup.vue?vue&type=style&index=0&id=6ea3b72d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports